import { css } from 'styled-components';
import { colors } from 'themes/variables';
const styles = css `
  display: flex;
  align-items: center;
  justify-content: center;

  .global-loader {
    width: ${(props) => props.size || 48}px;
    height: ${(props) => props.size || 48}px;
    border-radius: 50%;
    display: inline-block;
    border: ${(props) => props.thickness || 3}px solid ${colors.violetContainer};
    border-bottom-color: ${(props) => props.color || colors.purpleButton};
    box-sizing: border-box;
    animation: rotation ${(props) => props.speed || 1}s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
export default styles;
